import React, { useEffect, useState } from "react"
import { FlatList, View } from "react-native"
import styles from "./styles"
import { ActivityIndicator } from "react-native-paper"
import { baseColors } from "@Constants/baseStyles"
import { EmbeddedPost } from "./EmbeddedPost"
import { PostService } from "@Services/Posts"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { message } from "@Constants/constant"
import { generateUUID } from "@Utils/utils"

const Social = (props) => {
    const { navigation } = props
    const [selectedId, setSelectedId] = useState(null)
    const [socials, setSocials] = useState([])
    const [loading, setLoading] = useState(false)

    const fetchSocial = () => {
        setLoading(true)
        PostService.getSocialMedias()
            .then((response) => {
                const data = response.data?.data
                if (data) {
                    setSocials(data)
                }
                setLoading(false)
            })
            .catch((e) => {
                ShowToast({ type: "error", message: message.serverError })
                setLoading(false)
            })
    }

    useEffect(() => {
        fetchSocial()
    }, [])

    const renderItem = ({ item }) => {
        return <EmbeddedPost {...item} />
    }

    const handlePress = (id) => () => {
        setSelectedId(id)
        navigation.navigate("VideosDetails", { contentId: id })
    }

    return (
        <View style={styles.container}>
            {loading ? (
                <ActivityIndicator color={baseColors.green.primary} size={"large"} style={{ padding: 30 }} />
            ) : (
                <FlatList
                    data={socials}
                    showsVerticalScrollIndicator={false}
                    renderItem={renderItem}
                    keyExtractor={(item) => generateUUID()}
                    extraData={selectedId}
                    contentContainerStyle={styles.contentContainer}
                />
            )}
        </View>
    )
}

export default Social
